import React from "react";
import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { fadein, PopupModalContainer } from "./PopupModal.styles";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
};

export const LanguageMessageModal: React.FC<Props> = ({
  isOpen,
  handleClose,
}) => {
  if (!isOpen) return null;

  return (
    <PopupModalContainer $isOpen={isOpen}>
      <ModalContainer $isOpen={isOpen}>
        <LanguageMessageContent>
          日本語以外の言語は機械翻訳を使用しています。
          <br />
          翻訳されたページが正しいとは限りません。
          <br />
          お問い合わせは日本語でのみ受け付けております。
          <br />
          その他の言語でのお問い合わせにはお答えできませんのでご了承ください。
        </LanguageMessageContent>

        <Button btnStyle="primary" text="閉じる" onClick={handleClose} />
      </ModalContainer>
    </PopupModalContainer>
  );
};

const ModalContainer = styled.div<{ $isOpen: boolean }>`
  max-width: 300px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  background-color: white;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transform: ${({ $isOpen }) =>
    $isOpen
      ? "translate(-50%, -50%) scale(1, 1)"
      : "translate(-50%, -50%) scale(0.9, 0.9)"};
  padding: 20px 15px;
  animation: ${fadein} 0.5s forwards;
`;

const LanguageMessageContent = styled.p`
  font-size: 16px;
  line-height: 2;
  margin: 15px 10px;
`;
